// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"style_containerBox__1Gm8T","titleBox":"style_titleBox__25Iwl","carouselBox":"style_carouselBox__iP1b4","slide":"style_slide__FVLhK"};